import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeVehicleType } from '../../redux/actions/vehicleTypes';

interface Props {
  match: any;
  handleRemoveVehicleType: Function;
}

const Route = ({ match, handleRemoveVehicleType }: Props) => (
  <RouteWrapper
    title="Remove Vehicle Type"
    requireAuth
    requirePermission="MANAGE_VEHICLE_TYPES"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Type?</Title>
      <Subtitle>
        <p>
          Once this type is removed, you will not be able to assign vehicles to
          it anymore.
        </p>
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveVehicleType(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Type
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/settings/vehicles/types/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveVehicleType: (id) => {
    dispatch(removeVehicleType(id)).then((response) => {
      if (!response.error) {
        dispatch(goBack());
        dispatch(goBack());
      } else {
        dispatch(goBack());
      }
    });
  },
});

export default connect(() => ({}), mapDispatchToProps)(Route);
